import { getRequest, postRequest } from "../../utils/axios";

export const getProfileApi = (formData) =>
  getRequest("/users/profile", formData);

export const updateProfileApi = (formData) =>
  postRequest("/users/profile", formData);
